import { styled } from "@mui/material";

interface StyledIconContainer {
  disabled: boolean;
}

export const StyledPager = styled("div")`
  color: #ffffffeb;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${(props) => props.theme.wsc.spacing[1]};
`;

export const StyledPagerButton = styled("div")<StyledIconContainer>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 1.714rem;
  height: 1.714rem;
  border-radius: ${(props) => props.theme.wsc.radius.full};
  cursor: pointer;

  /* remove selection when click quickly */
  user-select: none;

  :hover {
    background-color: #ffffff66;
  }

  :active {
    box-sizing: border-box;
    border: 1px solid #ffffff99;
    background-color: #ffffff1f;
  }

  ${(props) =>
    props.disabled &&
    `
        pointer-events:none;
    `}
`;
